"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginForm = LoginForm;
exports.SignupFooter = SignupFooter;
exports.validation = exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var Yup = _interopRequireWildcard(require("yup"));
var _formik = require("formik");
var _reactI18next = require("react-i18next");
var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));
var _Hero = _interopRequireDefault(require("../Hero"));
var _HeroContent = _interopRequireDefault(require("../HeroContent"));
var _Input = _interopRequireWildcard(require("../Input"));
var _Button = _interopRequireDefault(require("../Button"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _FormLabel = _interopRequireDefault(require("../FormLabel"));
var _HeroHeader = _interopRequireDefault(require("../HeroHeader"));
var _HeroFooter = _interopRequireDefault(require("../HeroFooter"));
var _excluded = ["domain", "name", "className"],
  _excluded2 = ["handleSubmit", "isValid"],
  _excluded3 = ["disabled", "isSubmitting"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Login = function Login(_ref) {
  var form = _ref.form,
    signup = _ref.signup;
  return /*#__PURE__*/_react["default"].createElement(_Hero["default"], {
    left: /*#__PURE__*/_react["default"].createElement(Welcome, null)
  }, /*#__PURE__*/_react["default"].createElement(_HeroContent["default"], null, form, /*#__PURE__*/_react["default"].createElement("footer", null, signup)));
};
function Welcome(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col items-center h-full"
  }, /*#__PURE__*/_react["default"].createElement(_HeroHeader["default"], {
    hasLink: true,
    title: t('login.title'),
    subtitle: /*#__PURE__*/_react["default"].createElement("p", {
      className: "text-white text-sm flex items-center"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "opacity-50"
    }, t('login.subtitle')), /*#__PURE__*/_react["default"].createElement("span", {
      role: "img",
      "aria-label": "smile",
      className: "text-3xl ml-2 opacity-100"
    }, "\uD83D\uDE03"))
  }), /*#__PURE__*/_react["default"].createElement(_HeroFooter["default"], {
    className: "mb-5"
  }));
}
function SignupFooter(_ref2) {
  var onClick = _ref2.onClick;
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  return /*#__PURE__*/_react["default"].createElement("p", {
    className: "mt-10 text-xs text-light"
  }, t('login.signup.1'), ' ', /*#__PURE__*/_react["default"].createElement("span", {
    className: "cursor-pointer text-primary",
    onClick: onClick
  }, t('login.signup.2')));
}
function InputWithDomain(_ref3) {
  var domain = _ref3.domain,
    name = _ref3.name,
    className = _ref3.className,
    props = (0, _objectWithoutProperties2["default"])(_ref3, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: name
  }, function (_ref4) {
    var field = _ref4.field,
      form = _ref4.form;
    var value = field.value || '';
    value = value.slice(0, value.lastIndexOf('@'));
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex items-center bg-secondary"
    }, /*#__PURE__*/_react["default"].createElement(_Input["default"], (0, _extends2["default"])({}, props, {
      autoFocus: true,
      standalone: true,
      value: value,
      size: "lg",
      className: (0, _classnames["default"])(className, 'flex-1 font-bold'),
      onChange: function onChange(e) {
        form.setFieldValue(field.name, "".concat(e.target.value, "@").concat(domain));
      }
    })), /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
      title: domain
    }, /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: name,
      className: "text-primary font-bold pr-4 truncate",
      style: {
        maxWidth: '50%'
      }
    }, "@", domain)));
  });
}

// $FlowFixMe - why?
var validation = exports.validation = Yup.object().shape({
  email: Yup.string().trim().email().required(),
  password: Yup.string().trim().required()
});
function LoginForm(_ref5) {
  var domain = _ref5.domain,
    _onSubmit = _ref5.onSubmit,
    onForgot = _ref5.onForgot,
    isLoading = _ref5.isLoading,
    isCustomDomain = _ref5.isCustomDomain;
  var _useTranslation3 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation3.t;
  var inputClass = 'w-full py-2 px-4 block';
  return /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    initialValues: {
      email: '',
      password: ''
    },
    onSubmit: function onSubmit(values) {
      return _onSubmit(values.email.trim(), values.password);
    },
    validationSchema: validation
  }, function (_ref6) {
    var handleSubmit = _ref6.handleSubmit,
      isValid = _ref6.isValid,
      formikProps = (0, _objectWithoutProperties2["default"])(_ref6, _excluded2);
    return /*#__PURE__*/_react["default"].createElement(_formik.Form, {
      onSubmit: handleSubmit,
      className: "flex flex-col justify-between w-full h-full md:h-auto md:justify-start"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "h-full p-5 md:p-0"
    }, /*#__PURE__*/_react["default"].createElement("h1", {
      className: "mb-5 font-bold text-dark text-3xl md:text-4xl xl:text-5xl"
    }, t('login.header')), /*#__PURE__*/_react["default"].createElement("div", {
      className: "mb-5"
    }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
      htmlFor: "email"
    }, t('login.email')), isCustomDomain ? /*#__PURE__*/_react["default"].createElement(InputWithDomain, {
      name: "email",
      domain: domain,
      className: inputClass,
      placeholder: t('login.email.placeholder')
    }) : /*#__PURE__*/_react["default"].createElement(_Input["default"], {
      autoFocus: true,
      name: "email",
      size: "lg",
      className: (0, _classnames["default"])('font-bold', inputClass),
      placeholder: t('login.email.placeholder')
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "mb-8"
    }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
      htmlFor: "password"
    }, t('login.password')), /*#__PURE__*/_react["default"].createElement(_Input.PasswordInput, {
      visibleToggle: true,
      id: 'loginPasswordId',
      size: "lg",
      type: "password",
      name: "password",
      className: (0, _classnames["default"])('font-bold', inputClass),
      placeholder: t('login.password.placeholder')
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex justify-end"
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "mt-5 text-xs cursor-pointer text-light hover:text-primary",
      onClick: onForgot
    }, t('login.forgotPassword'))))), /*#__PURE__*/_react["default"].createElement(Submit, {
      type: "submit",
      disabled: !isValid,
      isSubmitting: isLoading
    }));
  });
}
function Submit(_ref7) {
  var disabled = _ref7.disabled,
    isSubmitting = _ref7.isSubmitting,
    rest = (0, _objectWithoutProperties2["default"])(_ref7, _excluded3);
  var _useTranslation4 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation4.t;
  var _useState = (0, _react.useState)(disabled),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    showAsDisabled = _useState2[0],
    setShowAsDisabled = _useState2[1];
  (0, _react.useEffect)(function () {
    var delayCheck = setTimeout(function () {
      var passwordInput = document.getElementById('loginPasswordId');
      try {
        if (passwordInput && passwordInput.matches(':-internal-autofill-selected')) {
          setShowAsDisabled(false);
        }
      } catch (e) {}
    }, 500);
    return function () {
      clearTimeout(delayCheck);
    };
  }, []);
  (0, _react.useEffect)(function () {
    setShowAsDisabled(disabled);
  }, [disabled]);
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    disabled: showAsDisabled || isSubmitting,
    className: "md:w-56"
  }, isSubmitting ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center justify-center"
  }, /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], {
    size: 24,
    color: "inherit"
  })) : t('login.submit'));
}
Submit.defaultProps = {
  disabled: false
};
var _default = exports["default"] = Login;
//# sourceMappingURL=index.js.map